import React, { useEffect, useState } from "react";
import axios from "axios";
import { Col, Container, Row } from "react-bootstrap";
import course from "../../../assets/images/course/course-detail.png";
import DOMPurify from "dompurify";
import { FaCalendar, FaCalendarAlt } from "react-icons/fa";

const NewsDetail = () => {
  const [blog, setBlog] = useState(null);
  const [imagePath, setImagePath] = useState("");
  const [bgImage, setBgImage] = useState("");
  const blogId = localStorage.getItem("selectedNewsId");
  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/news-view`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: blogId }),
          }
        );
        const data = await response.json();
        setBlog(data.data);
        setImagePath(data.imagePath);
        if (data.status === 1) {
          setBlog(data.data);
          setImagePath(data.imagePath);
        } else {
          console.error("Failed to load blog data");
        }
      } catch (err) {
        console.error("Error fetching blog:", err);
      }
    };

    if (blogId) {
      fetchBlogDetail();
    }
  }, [blogId]);
  const decodeHTML = (html) => {
    const parser = new DOMParser();
    const decoded = parser.parseFromString(html, "text/html");
    return decoded.documentElement.textContent;
  };

  useEffect(() => {
    bannerimg();
  }, []);
  const bannerimg = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
      );

      const baseUrl = res.data.imagePath;
      const courseImage = res.data.home_setting[0]?.course_image;

      // Full image URL
      const fullUrl = baseUrl + courseImage;

      setBgImage(fullUrl);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };

  const formatDateTime = (dateTime) => {
    if (!dateTime) return "";

    const [datePart, timePart] = dateTime.split(" ");
    if (!datePart || !timePart) return "";

    const [day, month, year] = datePart.split("-");
    const [hours, minutes] = timePart.split(":");

    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${day}-${month}-${year} ${h}:${minutes} ${ampm}`;
  };

  return (
    <>
      <section className="course">
        <div className="page_header"></div>
        <div className="rs-breadcrumbs breadcrumbs-overlay">
          <div className="breadcrumbs-img">
            <img src={bgImage} alt="Breadcrumbs bg" />
          </div>
          <div className="breadcrumbs-text white-color">
            <h1 className="page-title">News Detail</h1>
          </div>
        </div>
        <Container>
          <div className="blog_detail py-60">
            <Row>
              <Col lg={12}>
                <div className="blog_top d-flex gap-0 gap-md-5">
                  <div className="">
                    <p className="date d-flex align-items-center">
                      <FaCalendarAlt className="me-1" />
                      {blog?.date_time
                        ? formatDateTime(blog.date_time)
                        : "Loading..."}
                    </p>
                    <h2 className="mb-16">{blog?.title || ""}</h2>
                  </div>

                  <div>
                    <img
                      className="br-20 mb-24"
                      src={blog?.image ? `${imagePath}${blog.image}` : course}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = course;
                      }}
                      alt={blog?.title || "Blog Image"}
                    />
                  </div>
                </div>
              </Col>

              {/* Blog Image */}
              <Col lg={12}>
                <div
                  className="blog-description"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(blog?.description || ""),
                  }}
                ></div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default NewsDetail;
